import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class TmTicketTagDto extends DtoDetail {

    public ticketDtoId : number;
    public ticketDtoName : string;
    public ticketDtoImage : string;
    public ticketDtoColor : string;
    public tag : string;
   }